import { useState } from "react";
import { injectIntl } from "react-intl";
import { MenuItem } from "react-bootstrap";
import { useNavigate } from "react-router-dom-v5-compat";
import {
  ItemMenu,
  ListItem,
  ConfirmationModal,
  withApi,
  withNotifier,
  apiShape,
  productShape,
  intlShape,
  notifierShape,
  statusForProductStatus,
  url,
} from "lcm-iot-commons";

type OwnProps = {
  api: apiShape;
  intl: intlShape;
  notifier: notifierShape;
  showTenant?: boolean;
  removeProduct?: $TSFixMeFunction;
  product: productShape;
};

const defaultProps: Partial<OwnProps> = {
  showTenant: false,
  // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type '$TSFixMeFun... Remove this comment to see the full error message
  removeProduct: null,
};

type Props = OwnProps & typeof defaultProps;

export function ProductItem({
  product,
  api,
  intl,
  notifier,
  removeProduct,
  showTenant,
}: Props) {
  const [deleting, setDeleting] = useState(false);
  const navigate = useNavigate();

  const handleOnEditClick = () => {
    navigate(url(`/products/${(product as $TSFixMe).id}/edit`));
  };

  const handleOnDeleteClick = () => {
    setDeleting(true);
  };

  const handleClose = () => {
    setDeleting(false);
  };

  const handleConfirm = async () => {
    try {
      await (api as $TSFixMe).delete(`/products/${(product as $TSFixMe).id}`);
      setDeleting(false);
      if (removeProduct) await removeProduct((product as $TSFixMe).id);
      (notifier as $TSFixMe).showSuccess(
        (intl as $TSFixMe).formatMessage({
          id: "product.actions.delete.notification",
        }),
      );
    } catch (error) {
      setDeleting(false);
      (notifier as $TSFixMe).showError((api as $TSFixMe).translateError(error));
    }
  };

  const modalDeleting = deleting ? (
    <ConfirmationModal
      id="product-item-confirm"
      show
      titleText={(intl as $TSFixMe).formatMessage({
        id: "product.actions.delete.modal_title",
      })}
      messageText={(intl as $TSFixMe).formatMessage({
        id: "product.actions.delete.modal_message",
      })}
      onConfirm={() => handleConfirm()}
      onClose={() => handleClose()}
    />
  ) : null;

  const actions = (
    <div id="product-action-items">
      <ItemMenu>
        <MenuItem
          id="item-edit"
          onSelect={() => handleOnEditClick()}
          disabled={false}
        >
          {(intl as $TSFixMe).formatMessage({ id: "button.edit" })}
        </MenuItem>
        <MenuItem
          id="item-delete"
          onSelect={() => handleOnDeleteClick()}
          disabled={false}
        >
          {(intl as $TSFixMe).formatMessage({ id: "button.delete" })}
        </MenuItem>
      </ItemMenu>
      {modalDeleting}
    </div>
  );

  const name =
    (product as $TSFixMe).name ??
    (intl as $TSFixMe).formatMessage({ id: "product.no_name" });
  const tenant = (
    <span className="additional-info">
      ({(product as $TSFixMe).tenant?.name})
    </span>
  );

  const manufacturer = (
    <>
      {(product as $TSFixMe).manufacturer?.name}
      {showTenant ? " " : ""}
      {showTenant ? tenant : ""}
    </>
  );

  return (
    <ListItem
      id={`product-item-${(product as $TSFixMe).id}`}
      icon="lcm-iot-icon-product"
      actions={actions}
      title={name}
      target={url(`/products/${(product as $TSFixMe).id}`)}
      description={(product as $TSFixMe).product_code}
      value={manufacturer}
      status={statusForProductStatus(
        (product as $TSFixMe)?.status?.code ?? "undefined",
      )}
    />
  );
}

ProductItem.defaultProps = defaultProps;

export default injectIntl(withApi(withNotifier(ProductItem)));
